import React from "react";
import DarkModeToggle from "./DarkModeToggle";
import logosyn from "../assets/logosym.png";

const Navbar = ({ onLogout }) => {
  const email = localStorage.getItem("email");
  return (
    <nav className="w-full py-4 px-8 flex items-center justify-between ui-card shadow-neon">
      <div className="flex items-center gap-3">
        {/* <div className="h-10 w-10 rounded-lg flex items-center justify-center bg-gradient-to-br from-neon-purple to-neon-cyan text-black font-bold">
          G
        </div> */}
        <div className="h-10 w-10 rounded-lg overflow-hidden bg-white/0 flex items-center justify-center">
          <img src={logosyn} alt="Tasket" className="h-10 w-auto object-contain" />
        </div>
        <div>
          <div className="text-lg font-bold" style={{ fontFamily: "Inter, sans-serif" }}>
            Tasket
          </div>
          <div className="text-xs text-muted">Greenated's Task Management System</div>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <div className="hidden md:flex items-center gap-4">
          <span className="text-sm text-muted">
            User: <strong className="text-muted ml-2">{email}</strong>
          </span>
        </div>
        
        <button
          onClick={() => {
            localStorage.removeItem("token");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            window.location.href = "/login";
          }}
          className="px-3 py-2 rounded-lg text-sm border border-transparent hover:border-white/10 ui-card"
        >
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Navbar;